import { render, staticRenderFns } from "./CatalogoCartas.vue?vue&type=template&id=9bb3af24&scoped=true"
import script from "./CatalogoCartas.vue?vue&type=script&lang=js"
export * from "./CatalogoCartas.vue?vue&type=script&lang=js"
import style0 from "./CatalogoCartas.vue?vue&type=style&index=0&id=9bb3af24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb3af24",
  null
  
)

export default component.exports